import { jsx as _jsx } from "react/jsx-runtime";
import { TextButton } from 'seagull';
import { PaperclipAttachment } from 'seagull/icons';
import { DEFAULT_MAX_TOTAL_SIZE } from '~/hooks/useAttachFiles';
import { useLocaleKeys } from '~/i18n';
import styles from './AttachFiles.module.scss';
import { AttachFilesTestIds } from './AttachFiles.utils';
const AttachFiles = (param)=>{
    let { attachments, openFilePicker, isUploading, maxTotalSize = DEFAULT_MAX_TOTAL_SIZE, disabled } = param;
    const { t: attachFilesTexts } = useLocaleKeys('invoice.attachFiles');
    const currentTotalSize = attachments.reduce((sum, file)=>sum + file.fileSize, 0);
    const isSizeExceeded = currentTotalSize >= maxTotalSize;
    const isDisabled = disabled || isSizeExceeded || isUploading;
    const maxTotalSizeMB = maxTotalSize / (1024 * 1024);
    const getTooltip = ()=>{
        if (isUploading) {
            return {
                title: attachFilesTexts.tooltipUploading(),
                testId: AttachFilesTestIds.ButtonTooltip()
            };
        }
        if (isSizeExceeded) {
            return {
                title: attachFilesTexts.tooltipExceededLimit({
                    maxSizeMB: maxTotalSizeMB
                }),
                testId: AttachFilesTestIds.ButtonTooltip()
            };
        }
        return undefined;
    };
    return /*#__PURE__*/ _jsx(TextButton, {
        bi: {
            name: 'attach_files'
        },
        className: styles.button,
        testId: AttachFilesTestIds.Button(),
        underline: "none",
        weight: "normal",
        onClick: openFilePicker,
        prefixIcon: /*#__PURE__*/ _jsx(PaperclipAttachment, {}),
        disabled: isDisabled,
        tooltip: getTooltip(),
        children: attachFilesTexts.button()
    });
};
export default AttachFiles;
